import SocialLogins from './SocialLogins';
export default SocialLogins;
